import React, { useState } from 'react';
import { useForm } from '@formspree/react';
import { TextField, Typography } from '@mui/material';
import { MuiTelInput } from 'mui-tel-input';
import { Button, ButtonColor, ButtonSize, ButtonVariant } from '../Button';
import { ButtonPaddingSize } from '../Button/Button.types';
import './TeachersLeadForm.css';

const TeachersLeadForm = () => {
  const [state, handleSubmit] = useForm('mojjjdyn');
  const [formData, setFormData] = useState({
    name: '',
    university: '',
    own_university_subjects: '',
    how_did_you_hear: ''
  });
  const [phone, setPhone] = useState<string>('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const isFormValid = () => {
    return (
      formData.name.trim() !== '' &&
      formData.university.trim() !== '' &&
      formData.own_university_subjects.trim() !== '' &&
      formData.how_did_you_hear.trim() !== '' &&
      phone.trim() !== ''
    );
  };

  if (state.succeeded) {
    return (
      <div className="teachers-form-success">
        <Typography
          variant="h6"
          sx={{
            marginTop: '2%',
            marginBottom: '7%',
            alignContent: 'center',
            color: '#153240',
            fontSize: {
              sm: '1rem',
              xs: '0.9rem'
            },
            textAlign: 'center',
            padding: { xs: '0 1rem', sm: '0' }
          }}>
          ¡Muchas gracias! Recibimos tus datos, nos vamos a contactar pronto.
        </Typography>
      </div>
    );
  }

  return (
    <form
      className="teachers-lead-form"
      id="teachersLeadForm"
      name="teachers-lead-form"
      acceptCharset="utf-8"
      onSubmit={handleSubmit}>
      <TextField
        id="name"
        key="name"
        placeholder="Nombre y Apellido"
        variant="outlined"
        margin="dense"
        type="text"
        name="name"
        value={formData.name}
        onChange={handleChange}
        required
        fullWidth
      />
      <TextField
        id="university"
        key="university"
        placeholder="Universidad y Carrera"
        variant="outlined"
        margin="dense"
        type="text"
        name="university"
        value={formData.university}
        onChange={handleChange}
        required
        fullWidth
      />
      <TextField
        id="own-university-subjects"
        key="own-university-subjects"
        placeholder="Materias que darías de tu propia universidad (tal cual con el nombre que llevan en tu universidad)"
        variant="outlined"
        margin="dense"
        type="text"
        name="own_university_subjects"
        value={formData.own_university_subjects}
        onChange={handleChange}
        multiline
        rows={3}
        required
        fullWidth
      />
      <TextField
        id="other-university-subjects"
        key="other-university-subjects"
        placeholder="Otras materias de otras universidades que sepas que podés dar"
        variant="outlined"
        margin="dense"
        type="text"
        name="other_university_subjects"
        multiline
        rows={3}
        fullWidth
      />
      <TextField
        id="how-did-you-hear"
        key="how-did-you-hear"
        placeholder="¿Cómo te enteraste de nosotros?"
        variant="outlined"
        margin="dense"
        type="text"
        name="how_did_you_hear"
        value={formData.how_did_you_hear}
        onChange={handleChange}
        required
        fullWidth
      />
      <MuiTelInput
        id="phone"
        key="phone"
        placeholder="Teléfono"
        variant="outlined"
        margin="dense"
        required
        defaultCountry="AR"
        name="phone"
        value={phone}
        onChange={setPhone}
        fullWidth
      />
      <input
        type="hidden"
        name="_subject"
        id="email-subject"
        value="Nuevo Lead - Profesor Estudi"
      />
      <div className="teachers-lead-form-button">
        <Button
          variant={ButtonVariant.CONTAINED}
          type="submit"
          isLoading={state.submitting}
          disabled={!isFormValid() || state.submitting}
          color={ButtonColor.PRIMARY}
          size={ButtonSize.MD}
          paddingSize={ButtonPaddingSize.MD}>
          Enviar
        </Button>
      </div>
    </form>
  );
};

export default TeachersLeadForm;
